import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

import {ITreeNode} from '../models/grid-node.interface';

@Injectable()
export class NodeRemoveEmitterService {
  private removedNode$: Subject<ITreeNode> = new Subject<ITreeNode>();

  public emitNodeRemoved(node: ITreeNode) {
    this.removedNode$.next(node);
  }

  public subscribeToEmitter(): Observable<ITreeNode> {
    return this.removedNode$.asObservable();
  }
}
